<template>
    <div class="set-idfa-content">
        <el-form :model="params" ref="form" :label-width="labelWidth">
            <el-form-item label="启用状态：">
                <el-radio-group v-model="params.idfa_allowed">
                    <el-radio :label="true">启用</el-radio>
                    <el-radio :label="false">禁用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="调用方式：" v-if="params.idfa_allowed">
                <el-radio-group v-model="params.idfa_call_mode">
                    <el-radio label="udp">UDP</el-radio>
                    <el-radio label="cp">CP</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="弹窗类型：" v-if="params.idfa_allowed" style="position: relative">
                <el-radio-group v-model="params.idfa_popup_type">
                    <el-radio label="customize">定制弹窗 </el-radio>
                    <el-radio label="system">苹果系统弹窗</el-radio>
                </el-radio-group>
                <em class="el-icon-view icon-view" @click.stop="reviewDialogVisible = true"></em>
            </el-form-item>
            <div style="position: relative">
                <el-form-item label="弹窗时机：" v-if="isShowTime">
                    <el-radio-group v-model="params.idfa_time_type">
                        <el-radio label="after_login">
                            登录后
                            <el-input-number size="mini" class="w70 hidden"></el-input-number>
                            <span @click.stop style="color: #606266"> 分钟</span>
                        </el-radio>
                        <el-radio label="after_start" v-if="showSpecialTimeType">
                            启动后
                            <el-input-number size="mini" class="w70 hidden"></el-input-number>
                            <span @click.stop style="color: #606266"> 分钟</span>
                        </el-radio>
                    </el-radio-group>
                    <div style="color: #e6a23c">注：至多1440分钟</div>
                </el-form-item>
                <el-form-item v-if="isShowTime"
                              label-width="0"
                              class="after-login"
                              prop="after_login_time"
                              :rules="[
                        {
                            required: params.idfa_time_type === 'after_login',
                            message: ' '
                        }
                    ]">
                    <el-input-number v-model="params.after_login_time" :precision="1" :min="0" :max="1440"
                                     :controls="false" size="mini" class="w70"></el-input-number>
                </el-form-item>
                <el-form-item v-if="isShowTime && showSpecialTimeType"
                              label-width="0"
                              class="after-start"
                              prop="after_start_time"
                              :rules="[
                        {
                            required: params.idfa_time_type === 'after_start',
                            message: ' '
                        }
                    ]">
                    <el-input-number v-model="params.after_start_time" :precision="1" :min="0" :max="1440"
                                     :controls="false" size="mini" class="w70"></el-input-number>
                </el-form-item>
            </div>
            <div style="display: flex" v-if="params.idfa_allowed && params.idfa_popup_type === 'customize'">
                <el-form-item label="定制弹窗：" ></el-form-item>
                <div class="dialog-upload-btn-box">
                    <el-tabs v-model="dialogTemplateCustomName">
                        <el-tab-pane :name="key" v-for="(item, key) in params.idfa_customize_popup_image" :key="key">
                            <span slot="label">
                                {{key.toUpperCase()}}
                                <em :class="item.popup_background && item.allow_tracking_button && item.popup_close_button ? 'upload-success': 'upload-warning'"></em>
                            </span>
                            <el-checkbox v-model="item.checked" @change="handleIdfaCustomChecked(key)">将当前语言设置为默认语言</el-checkbox>
                            <div class="upload-imgs">
                                <el-form-item label-width="0">
                                    <div>弹窗背景图</div>
                                    <upload
                                        size="840 * 628px" formatlimit="all"
                                        v-model="item.popup_background"></upload>
                                </el-form-item>
                                <el-form-item label-width="20px">
                                    <div>弹框允许追踪按钮</div>
                                    <upload
                                        size="320 * 80px" formatlimit="all"
                                        v-model="item.allow_tracking_button"></upload>
                                </el-form-item>
                                <el-form-item label-width="20px">
                                    <div>关闭弹框按钮</div>
                                    <upload
                                        size="48 * 40px" formatlimit="all"
                                        v-model="item.popup_close_button"></upload>
                                </el-form-item>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
            <el-form-item>
                <el-button class="next-button" type="primary" size="small" @click="handlerNext">完成</el-button>
            </el-form-item>
        </el-form>
        <el-dialog
            class="el-dialog__body_self"
            title="IDFA设置指南"
            :visible.sync="reviewDialogVisible"
            width="820px" >
            <img src="../../assets/idfa_notice.png" alt="" style="margin-top: -100px;" />
        </el-dialog>
    </div>
</template>
<script>
import { mapState } from "vuex";
import upload from '../../subComponents/sdkUpload';
export default {
    name: 'set-idfa-allowed',
    components: {
        upload
    },
    data() {
        return {
            showSpecialTimeType:false,
            reviewDialogVisible: false,
            dialogTemplateCustomName: '',
            params: {
                idfa_customize_popup_image: {},
                idfa_allowed: true,
                idfa_call_mode: 'udp',
                idfa_popup_type: 'customize',
                idfa_time: undefined,
                idfa_time_type: 'after_login',
                after_login_time: undefined,
                after_start_time: undefined,
                step: 'idfa'
            }
        }
    },
    computed: {
        ...mapState([
            "$activeGameInfo",
            "$lodash"
        ]),
        ...mapState("sdkReleasesEdit", [
            "releasesInfo",
            "sdkVersion",
            "data"
        ]),
        isShowTime() {
            if(!this.params.idfa_allowed) {
                return false
            } else  if(this.params.idfa_call_mode === 'cp') {
                return false
            } else {
                return true
            }
        },
    },
    methods: {
        handleIdfaCustomChecked(key) {
            const currentKeyChecked = this.params.idfa_customize_popup_image[key].checked;
            for(let keys in this.params.idfa_customize_popup_image){
                this.params.idfa_customize_popup_image[keys].checked = false;
            }
            this.params.idfa_customize_popup_image[key].checked = currentKeyChecked;
            this.params.idfa_customize_popup_default_lang =currentKeyChecked? key : '';
        },
        handlerNext() {
            this.$refs['form'].validate((valid) => {
                if(valid) {
                    let params = this.$lodash.cloneDeep(this.params);
                    if(!params.idfa_allowed) {
                        delete params.idfa_time
                        delete params.idfa_time_type
                        delete params.idfa_popup_type
                        delete params.idfa_call_mode
                        delete params.idfa_customize_popup_image
                    } else if(!this.isShowTime) {
                        delete params.idfa_time
                        delete params.idfa_time_type
                    }
                    if(params.idfa_popup_type=== 'customize') {
                        try{
                            let isChecked = true;
                            this.$lodash.forEach(params.idfa_customize_popup_image, (item, key) => {
                                if(item.checked && (!item.popup_background || !item.allow_tracking_button || !item.popup_close_button)) {
                                    this.errorAlert();
                                    throw console.log('break');
                                }else if(!item.popup_background || !item.allow_tracking_button || !item.popup_close_button) {
                                    delete params.idfa_customize_popup_image[key];
                                    isChecked = false;
                                }
                            })
                            if(!isChecked && !params.idfa_customize_popup_default_lang) {
                                this.errorAlert();
                                throw console.log('break');
                            }
                        }catch(_){
                            return false;
                        }
                    }
                    if(this.isShowTime) {
                        params.idfa_time = params[ params.idfa_time_type+'_time']
                    }
                    this.$emit('submit', params, 'save')
                }
            })
        },
        errorAlert() {
            this.$alert('请检查IDFA定制弹框配置。您可以给所有语言配置弹框图片资源或将某个语言设置为默认语言。','提示');
        },
        justifyVersion(version) {
            let versionarr = version.split(".");
            let version_convert = '';
            if (versionarr[1] < 10) {
                version_convert = versionarr[0] + ".0" + versionarr[1];
            } else {
                version_convert = version;
            }
            return version_convert;
        },
    },
    props: ['isDetail', 'isCopy','labelWidth'],
    watch: {
        $activeGameInfo() {
            /**
             * 初始化定制弹窗
             */
            if(Array.isArray(this.$activeGameInfo.lang) && this.$activeGameInfo.lang.length){
                this.$activeGameInfo.lang.forEach(item => {
                    this.$set(this.params.idfa_customize_popup_image,item.full_code.toLowerCase(),{
                        popup_background: '',
                        allow_tracking_button: '',
                        popup_close_button: '',
                        checked: false
                    })
                })
                this.dialogTemplateCustomName = this.$activeGameInfo.lang[0].fullCode;
            }
        },
        'data.idfa'() {
            this.params = this.$lodash.cloneDeep(this.data.idfa);
            let idfa_customize_popup_image = {};
            this.$activeGameInfo.lang.forEach(item => {
                idfa_customize_popup_image[item.full_code.toLowerCase()] = {
                    popup_background: '',
                    allow_tracking_button: '',
                    popup_close_button: '',
                    checked: false
                }
            })
            this.$lodash.forEach(this.params.idfa_customize_popup_image, (item, key) => {
                if(this.params.idfa_customize_popup_default_lang === key) {
                    this.$set(this.params.idfa_customize_popup_image[key],'checked', true )
                }else {
                    this.$set(this.params.idfa_customize_popup_image[key],'checked', false )
                }
            })
            this.params[this.params.idfa_time_type+'_time'] = this.params.idfa_time;
            this.params.idfa_customize_popup_image = Object.assign(idfa_customize_popup_image,this.params.idfa_customize_popup_image);
            this.params.step = 'idfa';
        },
        'data.query'(value) {
            let version = "";
            this.sdkVersion.forEach(item => {
                if (parseInt(value.sdk_version_id) === parseInt(item.sdk_version_id)) {
                    version = item.version;
                }
            })
            const versionStr = version.substr(0, 2);
            version = this.justifyVersion(version);
            this.version = parseFloat(version);
            console.log(versionStr, this.version)
            if (['6.'].includes(versionStr) && this.version >= 6.04) {
                this.showSpecialTimeType = true;
            }

            if (!this.showSpecialTimeType && this.version >= 7.09) {
                this.showSpecialTimeType = true;
            }
        },
    }
}
</script>
<style lang="scss">
.set-idfa-content .el-dialog__body{
    overflow:hidden;
}
.set-idfa-content{
    .after-login {
        position: absolute;
        bottom: 25px;
        left: 225px;
        width: 120px;
    }
    .after-start {
        position: absolute;
        bottom: 25px;
        left: 456px;
        width: 120px;
    }
    .after-create-login {
        position: absolute;
        bottom: 25px;
        left: 686px;
        width: 120px;
    }
    .icon-view{
        left: 88px;
        top: 8px;
    }
    .w70{
        width: 70px;
        margin-left: 20px;
    }
    .hidden{
        visibility: hidden;
    }
    .dialog-upload-btn-box{
        .upload-imgs{
            display: flex;
            text-align: center;
            .avatar-box{
                border: 1px dashed #d9d9d9;
                border-radius: 6px
            }
        }
        .el-tabs__item{
            padding: 0!important;
            width: 70px;
            text-align: center;
        }
        .el-tabs__header{
            width: 560px;
        }
        .upload-success, .upload-warning{
            width: 5px;
            height: 5px;
            border-radius: 50%;
            display: inline-block;
            margin-bottom: 7px;
        }
        .upload-success{
            background: #67C23A;
        }
        .upload-warning{
            background: #F56C6C;
        }
    }
}

</style>



// WEBPACK FOOTER //
// website/subComponents/sdk/SetIdfaAllowed.vue